export default __webpack_public_path__ + "static/media/re.03e210d9.svg";